export enum FlagInputTypes {
    Score = 1,
    ClipStart = 2,
    ClipEnd = 3,
    Card = 4,
    CardReturn = 5
}